module.exports = __webpack_public_path__ + "img/Pablo-Serrano-Poster-01.ac823b1e.jpg";